<button class="icon-left" mat-icon-button [matMenuTriggerFor]="searchSelectMiltipleMenu" aria-label="Filter">
    <mat-icon [ngClass]="{'material-icons-outlined' : !hasFilterSelected()}">filter_alt</mat-icon>
</button>
<mat-menu #searchSelectMiltipleMenu="matMenu">
    <div class="menuContainer" (click)="$event.stopPropagation()">
        <div>
            <button class="clear-button" mat-icon-button (click)="clearFilters()">
                <div class="icon-container">
                    <mat-icon>block</mat-icon>
                </div>
                <span class="text-container">Clear filter</span>
            </button>
        </div>
        <div [hidden]="!activateSearch">
            <input class="searchInput" placeholder="Search..." (keyup)="applyFilter(searchInput.value)" #searchInput>
        </div>
        <div class="selection-list">
            <table mat-table class="lc-table" [dataSource]="dataSource">
                <!-- Checkbox Column -->
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (change)="$event ? masterToggle() : null"
                                      [checked]="selection.hasValue() && isAllSelected()"
                                      [indeterminate]="selection.hasValue() && !isAllSelected()"
                                      [aria-label]="'select'"
                                      color="primary">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox class="selection-checkbox" (click)="$event.stopPropagation()"
                            (change)="changeSelection($event, row)" [checked]="selection.isSelected(row)"
                            [aria-label]="row"
                            color="primary">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element"> {{element}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="changeSelection($event, row)"></tr>
            </table>
        </div>
    </div>
</mat-menu>